<ngx-adm-int-breadcrumb></ngx-adm-int-breadcrumb>
<div class="gymfinder">
  <router-outlet></router-outlet>
</div>
